import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { loadLegacyScripts } from './legacy/loadLegacyScripts.js';
import { initHeroReveal } from './legacy/initHeroReveal.js';
import { initPageEnhancements } from './legacy/pageEnhancements.js';
import { initBackToTop } from './legacy/backToTop.js';
import { clearLegacyServiceWorker } from './legacy/serviceWorker.js';

void clearLegacyServiceWorker();

const rootEl = document.getElementById('root');

if (rootEl) {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

async function bootstrap() {
  await loadLegacyScripts();
  initHeroReveal();
  initPageEnhancements();
  initBackToTop();
  await clearLegacyServiceWorker();
}

bootstrap().catch((err) => {
  console.error('[Vite] Legacy bootstrap failed:', err);
});
